import React, { useEffect, useState } from "react";
import PaceIcon from "assets/svgIcons/AdminDashboard/PaceIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { siteId as siteNumber } from "redux/reduxToolkitServices/_commonApiCalls/api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { API_STATUSES } from "redux/_helpers/statuses";

const DashboardPace = () => {
  const { t } = useTranslation();
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    dashboardPaceData,
    dashboardPaceStatus,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state.commonReducers) || "";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let courseId = globalCourseId.get();
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      let LastQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");
      dispatch(
        COMMON_SERVICES.getDashboardPaceServices(
          siteId.get(),
          LastQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteId.get(),
    siteSettingsData,
  ]);

  const redirectFunc = () => {
    navigate("/pace");
  };
  return (
    <>
      <div className="header" onClick={redirectFunc}>
        <PaceIcon />
        <p>{t("Pace")}</p>
      </div>
      <div className="box-body pace-section">
        {dashboardPaceStatus === "error" && <p>{t("Data_Not_Found")}</p>}

        <div>
          <h4>
            {dashboardPaceData && dashboardPaceData?.LastFastestPaceUpdated
              ? moment
                  .utc(dashboardPaceData?.LastFastestPaceUpdated)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")
              : ""}
          </h4>
          <p>
            {t("Fastest_pace")}{" "}
            {dashboardPaceData && dashboardPaceData?.FastestPace
              ? dashboardPaceData?.FastestPace
              : ""}{" "}
            {t("ahead")}
          </p>
        </div>
        <div>
          <h4>
            {dashboardPaceData && dashboardPaceData?.LastSlowestPaceUpdated
              ? moment
                  .utc(dashboardPaceData?.LastSlowestPaceUpdated)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")
              : ""}
          </h4>
          <p>
            {t("Slowest_pace")}{" "}
            {dashboardPaceData && dashboardPaceData?.SlowestPace
              ? dashboardPaceData?.SlowestPace
              : ""}{" "}
            {t("behind")}
          </p>
        </div>
        <div>
          <h4>
            {dashboardPaceData && dashboardPaceData?.LastAveragePaceUpdated
              ? moment
                  .utc(dashboardPaceData?.LastAveragePaceUpdated)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")
              : ""}
          </h4>
          <p>
            {t("Average_Pace")}{" "}
            {dashboardPaceData && dashboardPaceData?.AveragePace
              ? dashboardPaceData?.AveragePace > 0
                ? dashboardPaceData?.AveragePace + " " + t("ahead")
                : dashboardPaceData?.AveragePace < 0
                ? dashboardPaceData?.AveragePace + " " + t("behind")
                : dashboardPaceData?.AveragePace
              : ""}{" "}
          </p>
        </div>
      </div>
    </>
  );
};

export default DashboardPace;
